import { Component, OnInit, Input, EventEmitter, Output, ElementRef, ViewChild, OnChanges, signal } from '@angular/core';
import { IMPORTS } from './_imports';

@Component({
    selector: 'fod-model-editor',
    templateUrl: './fod-model-editor.component.html',
    styleUrl: './fod-model-editor.component.scss',
    standalone: true,
    imports: IMPORTS
})
export class FlowObjectDetailsModelEditorComponent implements OnInit, OnChanges {
    // #region [ViewChild]
    @ViewChild('wrapperRef') wrapperRef: ElementRef;
    // #endregion

    // #region [signals]
    $model = signal(null as string);
    $isReadOnlyMode = signal(false);
    $tinyMceOptions = signal(null as string);
    // #endregion

    // #region [Input/Output]
    @Input() _model: string;
    @Input() _isReadOnlyMode: boolean;
    @Input() _tinyMceOptions: string;
    @Output() _modelChange = new EventEmitter<string>();
    @Output() _onInitNgModelEvent = new EventEmitter<any>();
    @Output() _toggleEditAreaEvent = new EventEmitter<any>();
    @Output() _updateHtmlEditorAreaEvent = new EventEmitter<any>();
    // #endregion

    constructor() { }

    ngOnInit() { }

    ngOnChanges() {
        this.$model.set(this._model);
        this.$isReadOnlyMode.set(this._isReadOnlyMode);
        this.$tinyMceOptions.set(this._tinyMceOptions);
    }

    tinyMceFinishedLoading() {
        this._onInitNgModelEvent.emit();
    }

    toggleEditArea() {
        this._toggleEditAreaEvent.emit();
    }

    onSubmit() {
        if (this.$isReadOnlyMode()) return false;

        this._updateHtmlEditorAreaEvent.emit();
    }

    editorNgModelChange(event) {
        this._modelChange.emit(event);
    }

    // #region [===== private methods =====]
    // #endregion
}
